import React from 'react';
import { connect } from 'react-redux';

import { firebase } from 'firedb';

const auth = (Component) => {
	class WithAuthentication extends React.Component {
		componentDidMount() {
		// constructor(props) {
			// console.log("[auth system] cheking");

			const { onSetAuthUser } = this.props;

			firebase.auth.onAuthStateChanged(currentUser => {
				if (currentUser) {
					onSetAuthUser(currentUser);
					// user = currentUser;
				} else {
					onSetAuthUser(null);
					// user = null;
				}
			});

			// console.log("[auth system] " + user);
		}

		render() {
			// console.log("WithAuthentication render Component");

			return (

				<Component />
			
			);
		}
	}

	const mapDispatchToProps = (dispatch) => ({
		onSetAuthUser: (authUser) => dispatch({ type: 'AUTH_USER_SET', authUser }),
	});

	return connect(null, mapDispatchToProps)(WithAuthentication);
}

export default auth;



// WEBPACK FOOTER //
// ./src/layouts/Auth/auth.js